{
    "Profile_SupernovaCommercial_Memberships.header": "Memberships",
    "Profile_SupernovaCommercial_Memberships.membershipInformation": "Membership Information",
    "Profile_SupernovaCommercial_Memberships.membershipId": "CAA Business Membership Number"
}
